import { FormFieldBase } from './form-field-base.model';

export class FormFieldSharingDelete extends FormFieldBase<string> {
  override controlType = 'share-delete';
}
